<template>
    <div
        class="error-box"
        role="alert"
    >
        <div
            v-for="(fieldErrors, field, index) in errors"
            :key="index"
        >
            <!-- non field errors component has fieldErrors? -->
            <div
                v-for="(error, i) in fieldErrors"
                :key="i"
                class="message message--error-big"
            >
                {{ $capitalize($t(error).toString()) }}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'NonFieldErrors',
        props: {
            errors: {
                type: Object,
                required: true,
            },
        },
    };
</script>
